




import Vue from 'vue';
import InformationAdd from '@/components/information/information-add.component.vue';

export default Vue.extend({
  components: {
    'information-add': InformationAdd,
  },
});
